a.s.typepicker = (function(){
	var my = {
		pick:function(cb,o){
			a.loader.fs.create();
			tpl.run({tpl:'/tpl/shared/typepicker/popup.ejs?v='+v,data:{},cb:function(content){
				var token = a.popup.create({
					title:'Select type',
					width:500,
					height:400,
					content:content,
					close:function(){},
					ready:function(token){
						a.loader.fs.remove();
						my.init(token,cb);
					}
				});
			}});
		},
		init:function(token,cb){
			var win = $('#popupid_'+token);
			$.ajax({
				type:'GET',
				url:'/api/type/list/',
				data:{
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success && result.list) {
						tpl.run({tpl:'/tpl/shared/typepicker/list.ejs?v='+v,data:result,cb:function(content){
							$('div[data-area="list"]',win).empty().append(content);
							// Init actions
							$('ul.selectlist>li>div',win).unbind('click').click(function(){
								$('>ul',$(this).parent()).slideToggle(200);
								$('>i.arrow',this).toggleClass('open');
							});
							$('li[data-action="select"]').unbind('click').click(function(){
								cb({
									'success':true,
									'value':$(this).attr('data-tid'),
									'content':$(this).attr('data-content')
								});
								window.history.back();
							});
							$('button[data-action="manage_types"]',win).unbind('click').click(function(){
								require([res_path+'js/type.js'],
								function(){
									a.type.init({
										close:function(){
											my.init(token,cb);
										}
									});
								});
							});
						}});
					}
					else {
						tpl.run({tpl:'/tpl/shared/typepicker/list_empty.ejs?v='+v,data:result,cb:function(content){
							$('div[data-area="list"]',win).empty().append(content);
							// Init actions
							$('button[data-action="manage_types"]',win).unbind('click').click(function(){
								require([res_path+'js/type.js'],
								function(){
									a.type.init({
										close:function(){
											my.init(token,cb);
										}
									});
								});
							});
						}});
					}
				}
			});
		}
	}
	return my;
}());